import { useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

import { useDebounce } from "@/hooks/useDebounce";
import { captureException } from "@/utils/sentry";

import { adminLoginAsUser } from "@/store/auth";
import {
  usersGetAll,
  usersUpdateUser,
  usersCreateAgencyForUser,
} from "@/store/users";
import { billingUnsubscribeUserByAdmin } from "@/store/billing";
import { usersDeleteUser } from "@/store/users";

import { User } from '@/types'

import AppModal from "@/components/AppModal";
import AppText from "@/components/AppText";
import AppBox from "@/components/AppBox";
import AppButton from "@/components/AppButton";
import AfterHoursModal from "@/components/Modals/AfterHoursModal";

const Dashboard: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const { users, status, pagination } = useAppSelector((state) => state.users);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleCloseModal = async () => {
    setIsOpen(!isOpen)
  }

  return (
    <AppBox width={160}>
      <AppButton variant="outlined" onClick={() => setIsOpen(true)}>Set Hours</AppButton>

      <AppModal isOpen={isOpen} title="Set Hours" onClose={handleCloseModal}>
        <AfterHoursModal onClose={handleCloseModal} />
      </AppModal>
    </AppBox>
  );
};

export default Dashboard;